// ── The evidence query keys — declared ONCE, imported by every hook that reads or invalidates them ──
//
// ⚠ B-EVIDENCE-ARTIFACTS-QUERYKEY-MISMATCH: the provision mutation invalidated ['evidence-artifacts', ref]
//   while the list was cached under ['evidence-artifacts', 'control', ref] — a prefix that matched nothing,
//   so the evidence list never refreshed. A key typed twice is a key that drifts; this is the one place.

/** A control's evidence list (useControlEvidenceArtifacts). */
export const evidenceArtifactsKey = (reference: string) => ['evidence-artifacts', 'control', reference] as const;

/** A location's latest manual "Check for Evidence Updates" (Evidence monitoring S3). */
export const evidenceCheckKey = (reference: string | undefined) =>
  ['evidence-provisioning', 'location-check', reference] as const;
